// extracted by mini-css-extract-plugin
export default {"dataContainer":"styles_dataContainer__Jzk0W","tabsContainer":"styles_tabsContainer__h3Kux","active":"styles_active__eOF8x"};